var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_vm._v(" "+_vm._s(_vm.$t('bi.open-data.last-updated-at'))+": "),_c('div',[_vm._v(" "+_vm._s(_vm.lastDate)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }